import { Component } from '@angular/core';
import { EntityCrud } from '../../../shared/working/entity-crud/entity-crud';
import { ENTITY_CONFIGS } from '../entity-configs';

@Component({
  imports: [EntityCrud],
  selector: 'app-md-a7b95fe8',
  styleUrl: './md-a7b95fe8.css',
  templateUrl: './md-a7b95fe8.html',
})
export class MdA7b95fe8 {
  readonly config = ENTITY_CONFIGS['a7b95fe8'];
}
